/**
 * Text utility functions for transforming display text
 * Handles uppercase conversion and translations
 */

// Indonesian translation dictionary
const translations = {
  // Navigation
  "Dashboard": "DASBOR",
  "Projects": "PROYEK",
  "Create Project": "BUAT PROYEK",
  "Gantt Charts": "BAGAN GANTT",
  "S-Curve Analysis": "ANALISIS KURVA S",
  "Business Analytics": "ANALITIK BISNIS",
  "Project Overview": "IKHTISAR PROYEK",
  "Site Overview": "IKHTISAR LOKASI",
  "Task Overview": "IKHTISAR TUGAS",
  "Client Management": "MANAJEMEN KLIEN",
  "Quotations": "PENAWARAN",
  "Milestone Tracking": "PELACAKAN TONGGAK",
  "Active Projects": "PROYEK AKTIF",
  "Progress Photos": "FOTO KEMAJUAN",
  
  // Management Items
  "Work Items Master": "MASTER ITEM PEKERJAAN",
  "Teams": "TIM",
  "Budget Planning": "PERENCANAAN ANGGARAN",
  "Resource Planning": "PERENCANAAN SUMBER DAYA",
  "Vendor Management": "MANAJEMEN VENDOR",
  "Approval Center": "PUSAT PERSETUJUAN",
  "Team Management": "MANAJEMEN TIM",
  "Risk Management": "MANAJEMEN RISIKO",
  "Quality Control": "KONTROL KUALITAS",
  "Cost Control": "KONTROL BIAYA",
  "Update Progress": "PERBARUI KEMAJUAN",
  "Safety Management": "MANAJEMEN KESELAMATAN",
  "Quality Inspections": "INSPEKSI KUALITAS",
  "Worker Management": "MANAJEMEN PEKERJA",
  "Equipment Management": "MANAJEMEN PERALATAN",
  "Task Management": "MANAJEMEN TUGAS",
  "Technical Docs": "DOKUMEN TEKNIS",
  "Measurements": "PENGUKURAN",
  "Documents": "DOKUMEN",
  "Materials": "MATERIAL",
  
  // Reports
  "Business Reports": "LAPORAN BISNIS",
  "Sales Analytics": "ANALITIK PENJUALAN",
  "Profitability": "PROFITABILITAS",
  "Project Reports": "LAPORAN PROYEK",
  "Performance Analytics": "ANALITIK KINERJA",
  "Resource Utilization": "PEMANFAATAN SUMBER DAYA",
  "Daily Reports": "LAPORAN HARIAN",
  "Safety Reports": "LAPORAN KESELAMATAN",
  "Progress Reports": "LAPORAN KEMAJUAN",
  "Technical Reports": "LAPORAN TEKNIS",
  
  // Settings
  "Settings": "PENGATURAN",
  "Admin Panel": "PANEL ADMIN",
  "Profile": "PROFIL",
  "PENGATURAN": "PENGATURAN",
  "PROFIL SAYA": "PROFIL SAYA",
  "NOTIFIKASI": "NOTIFIKASI",
  "NOTIFIKASI OTOMATIS": "NOTIFIKASI OTOMATIS",
  "BAHASA": "BAHASA",
  "ADMIN PANEL": "ADMIN PANEL",
  "TAB PENGATURAN": "TAB PENGATURAN",
  "ANDA TIDAK MEMILIKI AKSES KE ADMIN PANEL. HANYA PENGGUNA DENGAN ROLE DIRECTOR YANG DAPAT MENGAKSES HALAMAN INI.": "ANDA TIDAK MEMILIKI AKSES KE ADMIN PANEL. HANYA PENGGUNA DENGAN ROLE DIRECTOR YANG DAPAT MENGAKSES HALAMAN INI.",
  
  // Profile Settings
  "INFORMASI DASAR": "INFORMASI DASAR",
  "UBAH PASSWORD": "UBAH PASSWORD",
  "SIMPAN PERUBAHAN": "SIMPAN PERUBAHAN",
  "USERNAME": "USERNAME",
  "EMAIL": "EMAIL",
  "NAMA LENGKAP": "NAMA LENGKAP",
  "NOMOR TELEPON": "NOMOR TELEPON",
  "PASSWORD SAAT INI": "PASSWORD SAAT INI",
  "PASSWORD BARU": "PASSWORD BARU",
  "KONFIRMASI PASSWORD BARU": "KONFIRMASI PASSWORD BARU",
  "GANTI FOTO PROFIL": "GANTI FOTO PROFIL",
  
  // Language Settings
  "PENGATURAN BAHASA": "PENGATURAN BAHASA",
  "PILIH BAHASA": "PILIH BAHASA",
  "PILIH BAHASA YANG INGIN ANDA GUNAKAN DI APLIKASI": "PILIH BAHASA YANG INGIN ANDA GUNAKAN DI APLIKASI",
  "PERUBAHAN BAHASA AKAN DITERAPKAN SETELAH ANDA MENYIMPAN PENGATURAN DAN MEMUAT ULANG APLIKASI.": "PERUBAHAN BAHASA AKAN DITERAPKAN SETELAH ANDA MENYIMPAN PENGATURAN DAN MEMUAT ULANG APLIKASI.",
  
  // Notification Settings
  "PENGATURAN NOTIFIKASI": "PENGATURAN NOTIFIKASI",
  "MENYIMPAN...": "MENYIMPAN...",
  "SIMPAN PENGATURAN": "SIMPAN PENGATURAN",
  "SALURAN NOTIFIKASI": "SALURAN NOTIFIKASI",
  "PILIH BAGAIMANA ANDA INGIN MENERIMA NOTIFIKASI": "PILIH BAGAIMANA ANDA INGIN MENERIMA NOTIFIKASI",
  "PENGATURAN NOTIFIKASI BERHASIL DISIMPAN": "PENGATURAN NOTIFIKASI BERHASIL DISIMPAN",
  "GAGAL MENYIMPAN PENGATURAN NOTIFIKASI": "GAGAL MENYIMPAN PENGATURAN NOTIFIKASI",
  "NOTIFIKASI PUSH": "NOTIFIKASI PUSH",
  "SMS": "SMS",
  "JENIS NOTIFIKASI": "JENIS NOTIFIKASI",
  "PILIH JENIS NOTIFIKASI YANG INGIN ANDA TERIMA": "PILIH JENIS NOTIFIKASI YANG INGIN ANDA TERIMA",
  
  // Admin Panel
  "KELOLA PENGGUNA, PERAN, PROYEK, DAN PENGATURAN SISTEM": "KELOLA PENGGUNA, PERAN, PROYEK, DAN PENGATURAN SISTEM",
  "MANAJEMEN PENGGUNA": "MANAJEMEN PENGGUNA",
  "PERAN & AKSES": "PERAN & AKSES",
  "MANAJEMEN PROYEK": "MANAJEMEN PROYEK",
  "PELANGGAN": "PELANGGAN",
  "KOORDINATOR PRODUKSI": "KOORDINATOR PRODUKSI",
  "SUBKONTRAKTOR": "SUBKONTRAKTOR",
  "INTEGRASI": "INTEGRASI",
  "BRANDING": "BRANDING",
  "LOG AUDIT": "LOG AUDIT",
  "TESTING & SIMULASI": "TESTING & SIMULASI",
  "INFO SISTEM": "INFO SISTEM",
  
  // Notification Polling Settings
  "PENGATURAN NOTIFIKASI OTOMATIS": "PENGATURAN NOTIFIKASI OTOMATIS",
  "PENGATURAN POLLING NOTIFIKASI": "PENGATURAN POLLING NOTIFIKASI",
  "ATUR BAGAIMANA SISTEM MEMERIKSA NOTIFIKASI BARU": "ATUR BAGAIMANA SISTEM MEMERIKSA NOTIFIKASI BARU",
  "AKTIFKAN PEMBARUAN OTOMATIS": "AKTIFKAN PEMBARUAN OTOMATIS",
  "NOTIFIKASI AKAN DIPERBARUI SECARA OTOMATIS": "NOTIFIKASI AKAN DIPERBARUI SECARA OTOMATIS",
  "NOTIFIKASI TIDAK AKAN DIPERBARUI OTOMATIS": "NOTIFIKASI TIDAK AKAN DIPERBARUI OTOMATIS",
  "INTERVAL PEMBARUAN": "INTERVAL PEMBARUAN",
  "SEBERAPA SERING SISTEM AKAN MEMERIKSA NOTIFIKASI BARU. DEFAULT 5 MENIT MEMBERIKAN KESEIMBANGAN YANG BAIK ANTARA RESPONSIVITAS DAN EFISIENSI.": "SEBERAPA SERING SISTEM AKAN MEMERIKSA NOTIFIKASI BARU. DEFAULT 5 MENIT MEMBERIKAN KESEIMBANGAN YANG BAIK ANTARA RESPONSIVITAS DAN EFISIENSI.",
  "SUARA NOTIFIKASI": "SUARA NOTIFIKASI",
  "PUTAR SUARA SAAT ADA NOTIFIKASI BARU (FITUR AKAN DATANG)": "PUTAR SUARA SAAT ADA NOTIFIKASI BARU (FITUR AKAN DATANG)",
  "NOTIFIKASI DESKTOP": "NOTIFIKASI DESKTOP",
  "TAMPILKAN NOTIFIKASI DESKTOP (FITUR AKAN DATANG)": "TAMPILKAN NOTIFIKASI DESKTOP (FITUR AKAN DATANG)",
  "TANDAI OTOMATIS SUDAH DIBACA": "TANDAI OTOMATIS SUDAH DIBACA",
  "OTOMATIS TANDAI NOTIFIKASI SEBAGAI SUDAH DIBACA SAAT DIKLIK": "OTOMATIS TANDAI NOTIFIKASI SEBAGAI SUDAH DIBACA SAAT DIKLIK",
  "RESET KE DEFAULT (5 MENIT)": "RESET KE DEFAULT (5 MENIT)",
  "STATUS SAAT INI": "STATUS SAAT INI",
  "INFORMASI PENGATURAN AKTIF": "INFORMASI PENGATURAN AKTIF",
  "STATUS NOTIFIKASI": "STATUS NOTIFIKASI",
  "AKTIF": "AKTIF",
  "NON-AKTIF": "NON-AKTIF",
  "TEST EMAIL": "TEST EMAIL",
  "MENGIRIM...": "MENGIRIM...",
  "EMAIL TEST BERHASIL DIKIRIM! SILAKAN PERIKSA KOTAK MASUK ANDA.": "EMAIL TEST BERHASIL DIKIRIM! SILAKAN PERIKSA KOTAK MASUK ANDA.",
  "GAGAL MENGIRIM EMAIL TEST. PASTIKAN EMAIL ANDA VALID DAN PENGATURAN EMAIL AKTIF.": "GAGAL MENGIRIM EMAIL TEST. PASTIKAN EMAIL ANDA VALID DAN PENGATURAN EMAIL AKTIF.",
  
  // Push Notifications
  "TEST PUSH": "TEST PUSH",
  "NOTIFIKASI PUSH TIDAK DIDUKUNG DI BROWSER INI": "NOTIFIKASI PUSH TIDAK DIDUKUNG DI BROWSER INI",
  "IZIN NOTIFIKASI PUSH BELUM DIBERIKAN": "IZIN NOTIFIKASI PUSH BELUM DIBERIKAN",
  "IZIN NOTIFIKASI PUSH DITOLAK. SILAKAN AKTIFKAN DI PENGATURAN BROWSER.": "IZIN NOTIFIKASI PUSH DITOLAK. SILAKAN AKTIFKAN DI PENGATURAN BROWSER.",
  "IZIN NOTIFIKASI PUSH DIPERLUKAN UNTUK MENGAKTIFKAN FITUR INI": "IZIN NOTIFIKASI PUSH DIPERLUKAN UNTUK MENGAKTIFKAN FITUR INI",
  "NOTIFIKASI PUSH BERHASIL DIAKTIFKAN": "NOTIFIKASI PUSH BERHASIL DIAKTIFKAN",
  "GAGAL MENGAKTIFKAN NOTIFIKASI PUSH": "GAGAL MENGAKTIFKAN NOTIFIKASI PUSH",
  "NOTIFIKASI PUSH BERHASIL DINONAKTIFKAN": "NOTIFIKASI PUSH BERHASIL DINONAKTIFKAN",
  "GAGAL MENONAKTIFKAN NOTIFIKASI PUSH": "GAGAL MENONAKTIFKAN NOTIFIKASI PUSH",
  "NOTIFIKASI PUSH TEST BERHASIL DIKIRIM!": "NOTIFIKASI PUSH TEST BERHASIL DIKIRIM!",
  "GAGAL MENGIRIM NOTIFIKASI PUSH TEST": "GAGAL MENGIRIM NOTIFIKASI PUSH TEST",
  "DAPATKAN PEMBERITAHUAN MELALUI EMAIL UNTUK SEMUA AKTIVITAS PENTING": "DAPATKAN PEMBERITAHUAN MELALUI EMAIL UNTUK SEMUA AKTIVITAS PENTING",
  "DAPATKAN PEMBERITAHUAN LANGSUNG DI BROWSER ATAU APLIKASI MOBILE": "DAPATKAN PEMBERITAHUAN LANGSUNG DI BROWSER ATAU APLIKASI MOBILE",
  "DAPATKAN PEMBERITAHUAN SMS UNTUK PERINGATAN PENTING": "DAPATKAN PEMBERITAHUAN SMS UNTUK PERINGATAN PENTING",
  "PERUBAHAN STATUS PROYEK, PEMBARUAN DOKUMEN, DAN INFORMASI PROYEK LAINNYA": "PERUBAHAN STATUS PROYEK, PEMBARUAN DOKUMEN, DAN INFORMASI PROYEK LAINNYA",
  "PEMBERITAHUAN SAAT TUGAS BARU DITUGASKAN KEPADA ANDA": "PEMBERITAHUAN SAAT TUGAS BARU DITUGASKAN KEPADA ANDA",
  "LAPORAN KEMAJUAN MINGGUAN DAN BULANAN": "LAPORAN KEMAJUAN MINGGUAN DAN BULANAN",
  "PERMINTAAN PERSETUJUAN UNTUK DOKUMEN, ANGGARAN, ATAU PERUBAHAN": "PERMINTAAN PERSETUJUAN UNTUK DOKUMEN, ANGGARAN, ATAU PERUBAHAN",
  "PENGUMUMAN SISTEM DAN PEMBARUAN PLATFORM": "PENGUMUMAN SISTEM DAN PEMBARUAN PLATFORM",
  "RINGKASAN HARIAN DARI SEMUA AKTIVITAS": "RINGKASAN HARIAN DARI SEMUA AKTIVITAS",
  "RINGKASAN MINGGUAN DARI SEMUA AKTIVITAS": "RINGKASAN MINGGUAN DARI SEMUA AKTIVITAS",
  
  // Header
  "Hakiki Steel - Project Management": "HAKIKI STEEL - MANAJEMEN PROYEK",
  "View All Notifications": "LIHAT SEMUA NOTIFIKASI",
  "Notification Settings": "PENGATURAN NOTIFIKASI",
  "Bahasa Indonesia": "BAHASA INDONESIA",
  "English": "INGGRIS",
  "Logout": "KELUAR",
  
  // Category Labels
  "Business Management": "MANAJEMEN BISNIS",
  "Project Control": "KONTROL PROYEK",
  "Site Operations": "OPERASI LOKASI",
  "Field Work": "PEKERJAAN LAPANGAN",
  "Management": "MANAJEMEN",
  "Analytics & Reports": "ANALITIK & LAPORAN",
  "Performance & Reports": "KINERJA & LAPORAN",
  "Site Reports": "LAPORAN LOKASI",
  "Progress & Reports": "KEMAJUAN & LAPORAN",
  "Reports": "LAPORAN",
  
  // Common UI Elements
  "Save": "SIMPAN",
  "Cancel": "BATAL",
  "Delete": "HAPUS",
  "Edit": "EDIT",
  "Add": "TAMBAH",
  "Remove": "HAPUS",
  "Search": "CARI",
  "Filter": "FILTER",
  "Sort": "URUT",
  "Submit": "KIRIM",
  "Reset": "RESET",
  "Back": "KEMBALI",
  "Next": "LANJUT",
  "Previous": "SEBELUMNYA",
  "Yes": "YA",
  "No": "TIDAK",
  "OK": "OKE",
  "Confirm": "KONFIRMASI",
  "Success": "BERHASIL",
  "Error": "KESALAHAN",
  "Warning": "PERINGATAN",
  "Info": "INFO",
  "Loading": "MEMUAT",
  "Required": "WAJIB",
  "Optional": "OPSIONAL",
  "Select": "PILIH",
  "All": "SEMUA",
  "None": "TIDAK ADA",
  "Date": "TANGGAL",
  "Time": "WAKTU",
  "From": "DARI",
  "To": "KE",
  "Status": "STATUS",
  "Actions": "TINDAKAN",
  "Details": "DETAIL",
  "Description": "DESKRIPSI",
  "Name": "NAMA",
  "Title": "JUDUL",
  "Type": "TIPE",
  "Category": "KATEGORI",
  "Priority": "PRIORITAS",
  "High": "TINGGI",
  "Medium": "SEDANG",
  "Low": "RENDAH",
  "Start Date": "TANGGAL MULAI",
  "End Date": "TANGGAL SELESAI",
  "Duration": "DURASI",
  "Progress": "KEMAJUAN",
  "Complete": "SELESAI",
  "Incomplete": "BELUM SELESAI",
  "Pending": "TERTUNDA",
  "Approved": "DISETUJUI",
  "Rejected": "DITOLAK",
  "In Progress": "DALAM PROSES",
  "Not Started": "BELUM DIMULAI",
  "Finished": "SELESAI",
  "Delayed": "TERTUNDA",
  "On Time": "TEPAT WAKTU",
  "Late": "TERLAMBAT",
  "Early": "LEBIH AWAL",
  "Percentage": "PERSENTASE",
  "Total": "TOTAL",
  "Subtotal": "SUBTOTAL",
  "Quantity": "KUANTITAS",
  "Unit": "SATUAN",
  "Price": "HARGA",
  "Cost": "BIAYA",
  "Amount": "JUMLAH",
  "Budget": "ANGGARAN",
  "Actual": "AKTUAL",
  "Variance": "VARIAN",
  "Planned": "DIRENCANAKAN",
  "User": "PENGGUNA",
  "Password": "KATA SANDI",
  "Email": "EMAIL",
  "Phone": "TELEPON",
  "Address": "ALAMAT",
  "City": "KOTA",
  "State": "PROVINSI",
  "Country": "NEGARA",
  "Zip Code": "KODE POS",
  "Role": "PERAN",
  "Permissions": "IZIN",
  "Access": "AKSES",
  "Login": "MASUK",
  "Register": "DAFTAR",
  "Forgot Password": "LUPA KATA SANDI",
  "Remember Me": "INGAT SAYA",
  "Sign In": "MASUK",
  "Sign Out": "KELUAR",
  "Sign Up": "DAFTAR",
  "Username": "NAMA PENGGUNA",
  "First Name": "NAMA DEPAN",
  "Last Name": "NAMA BELAKANG",
  "Full Name": "NAMA LENGKAP",
  "Company": "PERUSAHAAN",
  "Department": "DEPARTEMEN",
  "Position": "POSISI",
  "Manager": "MANAJER",
  "Supervisor": "SUPERVISOR",
  "Employee": "KARYAWAN",
  "Client": "KLIEN",
  "Customer": "PELANGGAN",
  "Vendor": "VENDOR",
  "Supplier": "PEMASOK",
  "Contractor": "KONTRAKTOR",
  "Subcontractor": "SUBKONTRAKTOR",
  "Partner": "MITRA",
  "Stakeholder": "PEMANGKU KEPENTINGAN",
  "Team Member": "ANGGOTA TIM",
  "Project Manager": "MANAJER PROYEK",
  "Site Manager": "MANAJER LOKASI",
  "Site Engineer": "INSINYUR LOKASI",
  "Director": "DIREKTUR",
  "Administrator": "ADMINISTRATOR",
  "Admin": "ADMIN",
  "Guest": "TAMU",
  
  // Login Page
  "PILIH JABATAN": "PILIH JABATAN",
  "ADMIN": "ADMIN",
  "PROJECT MANAGER": "MANAJER PROYEK",
  "SITE MANAGER": "MANAJER LOKASI",
  "SITE ENGINEER": "INSINYUR LOKASI",
  "COMMERCIAL": "KOMERSIAL",
  "CUSTOMER": "PELANGGAN",
  "INVALID EMAIL AND ROLE COMBINATION. PLEASE SELECT THE CORRECT ROLE FOR YOUR ACCOUNT.": "KOMBINASI EMAIL DAN JABATAN TIDAK VALID. SILAKAN PILIH JABATAN YANG BENAR UNTUK AKUN ANDA.",
  "YOU DON'T HAVE PRIVILEGES. PLEASE LOGIN WITH YOUR ASSIGNED ROLE.": "ANDA TIDAK MEMILIKI HAK AKSES. SILAKAN LOGIN DENGAN JABATAN YANG DITETAPKAN.",
  "LOGIN FAILED. PLEASE CHECK YOUR CREDENTIALS.": "LOGIN GAGAL. SILAKAN PERIKSA KREDENSIAL ANDA.",
  "LOGIN SUCCESSFUL!": "LOGIN BERHASIL!",
  "GOOGLE LOGIN FAILED": "LOGIN GOOGLE GAGAL",
  "FAILED TO INITIALIZE GOOGLE LOGIN:": "GAGAL MENGINISIALISASI LOGIN GOOGLE:",
  "GOOGLE LOGIN FAILED. PLEASE TRY AGAIN OR USE USERNAME/PASSWORD.": "LOGIN GOOGLE GAGAL. SILAKAN COBA LAGI ATAU GUNAKAN USERNAME/PASSWORD.",
  "GOOGLE LOGIN IS NOT CONFIGURED PROPERLY. PLEASE USE USERNAME/PASSWORD INSTEAD.": "LOGIN GOOGLE TIDAK DIKONFIGURASI DENGAN BENAR. SILAKAN GUNAKAN USERNAME/PASSWORD SEBAGAI GANTINYA.",
  "SILAKAN MASUKKAN EMAIL ANDA": "SILAKAN MASUKKAN EMAIL ANDA",
  "INSTRUKSI RESET PASSWORD TELAH DIKIRIM KE EMAIL ANDA": "INSTRUKSI RESET PASSWORD TELAH DIKIRIM KE EMAIL ANDA",
  "GAGAL MENGIRIM PERMINTAAN RESET PASSWORD": "GAGAL MENGIRIM PERMINTAAN RESET PASSWORD",
  "EMAIL TERKIRIM": "EMAIL TERKIRIM",
  "LUPA PASSWORD": "LUPA PASSWORD",
  "INSTRUKSI RESET PASSWORD TELAH DIKIRIM KE EMAIL ANDA. SILAKAN PERIKSA KOTAK MASUK ANDA.": "INSTRUKSI RESET PASSWORD TELAH DIKIRIM KE EMAIL ANDA. SILAKAN PERIKSA KOTAK MASUK ANDA.",
  "MASUKKAN ALAMAT EMAIL ANDA DAN KAMI AKAN MENGIRIMKAN INSTRUKSI UNTUK MERESET PASSWORD ANDA.": "MASUKKAN ALAMAT EMAIL ANDA DAN KAMI AKAN MENGIRIMKAN INSTRUKSI UNTUK MERESET PASSWORD ANDA.",
  "KIRIM INSTRUKSI RESET": "KIRIM INSTRUKSI RESET",
  "MASUKKAN DETAIL LOGIN ANDA DI BAWAH INI": "MASUKKAN DETAIL LOGIN ANDA DI BAWAH INI",
  "MASUKKAN EMAIL": "MASUKKAN EMAIL",
  "EMAIL HARUS DIISI": "EMAIL HARUS DIISI",
  "MASUKKAN PASSWORD": "MASUKKAN PASSWORD",
  "PASSWORD HARUS DIISI": "PASSWORD HARUS DIISI",
  "JABATAN": "JABATAN",
  "JABATAN HARUS DIISI": "JABATAN HARUS DIISI",
  "LUPA PASSWORD?": "LUPA PASSWORD?",
  "MASUK": "MASUK",
  "ATAU LANJUTKAN": "ATAU LANJUTKAN",
  "MASUK DENGAN GOOGLE": "MASUK DENGAN GOOGLE",
  
  // Project Management
  "Project Management": "MANAJEMEN PROYEK",
  
  // Import Dialog
  "DOWNLOAD TEMPLATE": "UNDUH TEMPLATE/UNDUH TASK YANG SUDAH ADA",
  "UPLOAD FILE": "UNGGAH FILE",
  "HASIL IMPORT": "HASIL IMPORT",
  "DOWNLOAD TEMPLATE IMPORT": "UNDUH TEMPLATE IMPORT",
  "DOWNLOAD TEMPLATE EXCEL YANG SUDAH BERISI FORMAT YANG BENAR UNTUK IMPORT DATA PROYEK": "UNDUH TEMPLATE EXCEL YANG SUDAH BERISI FORMAT YANG BENAR UNTUK IMPORT DATA PROYEK",
  "TEMPLATE BERISI 3 SHEET:": "TEMPLATE BERISI 4 SHEET:",
  "KATEGORI PEKERJAAN": "KATEGORI PEKERJAAN",
  "KATEGORI PEKERJAAN (CIVIL, ELECTRICAL, DLL)": "KATEGORI PEKERJAAN (CIVIL, ELECTRICAL, DLL)",
  "UNIT MODULAR": "UNIT MODULAR",
  "UNIT MODULAR ATAU AREA KERJA": "UNIT MODULAR ATAU AREA KERJA",
  "DAFTAR PEKERJAAN": "DAFTAR PEKERJAAN",
  "DAFTAR PEKERJAAN DENGAN DEPENDENCIES": "DAFTAR PEKERJAAN DENGAN DEPENDENCIES",
  "UPLOAD FILE IMPORT": "UNGGAH FILE IMPORT",
  "PILIH FILE EXCEL YANG SUDAH DIISI SESUAI TEMPLATE": "PILIH FILE EXCEL YANG SUDAH DIISI SESUAI TEMPLATE",
  "PILIH FILE": "PILIH FILE",
  "FILE TERPILIH": "FILE TERPILIH",
  "UKURAN": "UKURAN",
  "ERROR SAAT IMPORT:": "ERROR SAAT IMPORT:",
  "MENGUPLOAD...": "MENGUPLOAD...",
  "UPLOAD & IMPORT": "UNGGAH & IMPORT",
  "SEDANG MEMPROSES FILE...": "SEDANG MEMPROSES FILE...",
  "IMPORT BERHASIL!": "IMPORT BERHASIL!",
  "DATA BERHASIL DIIMPORT KE PROYEK": "DATA BERHASIL DIIMPORT KE PROYEK",
  "DETAIL IMPORT:": "DETAIL IMPORT:",
  "SELESAI": "SELESAI",
  "BATAL": "BATAL",
  "KEMBALI": "KEMBALI",
  "IMPORT STRUKTUR PROYEK": "IMPORT STRUKTUR PROYEK",
  "TUTUP": "TUTUP",
  "UPLOAD LANGSUNG": "UNGGAH LANGSUNG",
  "SUDAH PUNYA FILE? KLIK \"UPLOAD LANGSUNG\" UNTUK MELEWATI DOWNLOAD TEMPLATE": "SUDAH PUNYA FILE? KLIK \"UNGGAH LANGSUNG\" UNTUK MELEWATI UNDUH TEMPLATE",
  
  // Master Job Selector
  "CARI ITEM PEKERJAAN MASTER": "CARI ITEM PEKERJAAN MASTER",
  "KETIK MINIMAL 2 KARAKTER...": "KETIK MINIMAL 2 KARAKTER...",
  "CARI BERDASARKAN KODE ATAU NAMA ITEM PEKERJAAN": "CARI BERDASARKAN KODE ATAU NAMA ITEM PEKERJAAN",
  "MEMUAT...": "MEMUAT...",
  "MEMUAT ITEM PEKERJAAN...": "MEMUAT ITEM PEKERJAAN...",
  "TIDAK ADA ITEM PEKERJAAN YANG COCOK DITEMUKAN": "TIDAK ADA ITEM PEKERJAAN YANG COCOK DITEMUKAN",
  "TIDAK ADA ITEM PEKERJAAN MASTER YANG DITEMUKAN. SILAKAN TAMBAHKAN BEBERAPA DI MENU DAFTAR MASTER ITEM PEKERJAAN TERLEBIH DAHULU.": "TIDAK ADA ITEM PEKERJAAN MASTER YANG DITEMUKAN. SILAKAN TAMBAHKAN BEBERAPA DI MENU DAFTAR MASTER ITEM PEKERJAAN TERLEBIH DAHULU.",
  "GAGAL MEMUAT ITEM PEKERJAAN MASTER": "GAGAL MEMUAT ITEM PEKERJAAN MASTER",
  "TIDAK ADA HASIL YANG DITEMUKAN UNTUK": "TIDAK ADA HASIL YANG DITEMUKAN UNTUK",
  "GAGAL MENCARI ITEM PEKERJAAN MASTER": "GAGAL MENCARI ITEM PEKERJAAN MASTER",
  "KESALAHAN KONEKSI: PERIKSA BAHWA BACKEND BERJALAN DI http://localhost:3000": "KESALAHAN KONEKSI: PERIKSA BAHWA BACKEND BERJALAN DI http://localhost:3000",
  "TIDAK ADA ITEM PEKERJAAN MASTER YANG TERSEDIA. ANDA MUNGKIN PERLU MEMBUAT BEBERAPA TERLEBIH DAHULU DI DAFTAR MASTER ITEM PEKERJAAN.": "TIDAK ADA ITEM PEKERJAAN MASTER YANG TERSEDIA. ANDA MUNGKIN PERLU MEMBUAT BEBERAPA TERLEBIH DAHULU DI DAFTAR MASTER ITEM PEKERJAAN.",
  "DIPILIH": "DIPILIH",
  
  // Units
  "M³ (KUBIK)": "M³ (KUBIK)",
  "M² (PERSEGI METER)": "M² (PERSEGI METER)",
  "M (METER LINIER)": "M (METER LINIER)",
  "LS (LUMPSUM)": "LS (LUMPSUM)",
  "UNIT": "UNIT",
  "PCS": "PCS",
  "SET": "SET",
  "TITIK": "TITIK",
  "EA (EACH)": "EA (EACH)"
};

// Add more translations for AddTaskDialog
translations["M³ (KUBIK)"] = "M³ (KUBIK)";
translations["M² (PERSEGI METER)"] = "M² (PERSEGI METER)";
translations["M (METER LINIER)"] = "M (METER LINIER)";
translations["LS (LUMPSUM)"] = "LS (LUMPSUM)";
translations["UNIT"] = "UNIT";
translations["PCS"] = "PCS";
translations["SET"] = "SET";
translations["TITIK"] = "TITIK";
translations["EA (EACH)"] = "EA (EACH)";

// Dashboard translations
translations["PERIODE LALU"] = "PERIODE LALU";
translations["PERIODE INI"] = "PERIODE INI";
translations["PROGRESS TOTAL"] = "PROGRESS TOTAL";
translations["PROGRESS KATEGORI"] = "PROGRESS KATEGORI";
translations["PROGRESS TASK PER KATEGORI"] = "PROGRESS TASK PER KATEGORI";
translations["PROGRESS BANGUNAN"] = "PROGRESS BANGUNAN";
translations["MULAI"] = "MULAI";
translations["SELESAI"] = "SELESAI";
translations["BANGUNAN"] = "BANGUNAN";
translations["KATEGORI"] = "KATEGORI";
translations["HARI"] = "HARI";
translations["TASK NAME"] = "NAMA TASK";
translations["START DATE"] = "TANGGAL MULAI";
translations["END DATE"] = "TANGGAL SELESAI";
translations["DURATION"] = "DURASI";
translations["LATE TASKS"] = "TASK TERLAMBAT";
translations["TIDAK ADA KATEGORI DALAM PROJECT INI"] = "TIDAK ADA KATEGORI DALAM PROJECT INI";
translations["TIDAK ADA TASK DALAM KATEGORI INI"] = "TIDAK ADA TASK DALAM KATEGORI INI";
translations["TIDAK ADA TASK DALAM UNIT BANGUNAN INI"] = "TIDAK ADA TASK DALAM UNIT BANGUNAN INI";
translations["TIDAK ADA BANGUNAN DALAM PROJECT INI"] = "TIDAK ADA BANGUNAN DALAM PROJECT INI";
translations["TIDAK ADA MILESTONE YANG AKAN JATUH TEMPO"] = "TIDAK ADA MILESTONE YANG AKAN JATUH TEMPO";

/**
 * Transforms text to uppercase Indonesian
 * @param {string} text - Original English text
 * @returns {string} - Uppercase Indonesian translation
 */
export const transformText = (text) => {
  if (!text) return '';
  
  // Check if we have a translation
  const translation = translations[text] || text.toUpperCase();
  
  return translation;
};

/**
 * Transforms text to uppercase Indonesian with fallback to original text in uppercase
 * @param {string} text - Original English text
 * @returns {string} - Uppercase Indonesian translation or original text in uppercase
 */
export const t = (text) => {
  return transformText(text);
};

const textUtils = {
  transformText,
  t
};

export default textUtils;
